import axios from "../../axios/axios-api";
import axiosCenso from "../../axios/axios-censo";

export const pegaCategoriasLp = ({ commit }) => {

    return axiosCenso
    .get("listarCategoriasLongaPermanencia.php")
    .then(resp => {
        resp.data.status == true ? commit("setCategoriasLp", resp.data.dados) : commit("setCategoriasLp", new Array())
    })
    .catch(error => {
        console.log(error)
    });
};

export const pegaListaUnidadesProcedenciaLP = ({ commit }) => {

    return axiosCenso
    .get("listarUnidadeProcedenciaLP.php")
    .then(resp => {
        commit("setUnidadesProcedenciaLP", resp.data.dados)
    })
    .catch(error => {
        console.log(error)
    });
}

export const inserirCasoSocial = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .post("/api/longapermanencia/inserirCasoSocial", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });
};

export const inserirOutros = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .post("/api/longapermanencia/inserirOutros", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });
};

export const editarOutros = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .put("/api/longapermanencia/alterarOutros", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });
};

export const editarCasoSocial = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .put("/api/longapermanencia/alterarCasoSocial", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });
};

export const pegaDadosPacienteLp = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let config = {
        headers: { Authorization: "Bearer " + token },
        params: {
            filtro: 'idInternacao',
            palavraChave: payload
        }
    }

    return axios
    .get("/api/longapermanencia/listar", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("setDadosPacienteLp", resp.data.dados[0])
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });
};
